import React from 'react';
import classNames from 'classnames';
import { NamedLink } from '../../../../components';
import { useIntl } from '../../../../util/reactIntl';
import { ArrowRightIcon, CheckCircle2Icon } from '../MerchantIcons';
import css from './Pricing.module.css';

const PRICING_ITEMS = [
  'ForBusiness.pricingItem1',
  'ForBusiness.pricingItem2',
  'ForBusiness.pricingItem3',
];

const Pricing = () => {
  const intl = useIntl();
  const arabicLanguage =
    typeof window !== 'undefined' && localStorage.getItem('language') === 'Arabic';

  return (
    <section className={classNames(css.section, arabicLanguage && css.arabicDirection)}>
      <div className={css.inner}>
        <div className={css.header}>
          <h2 className={css.title}>{intl.formatMessage({ id: 'ForBusiness.pricingTitle' })}</h2>
          <p className={css.subtitle}>{intl.formatMessage({ id: 'ForBusiness.pricingSub' })}</p>
        </div>

        <div className={css.card}>
          <div className={css.badge}>
            {intl.formatMessage({ id: 'ForBusiness.pricingBadge' })}
          </div>
          <div className={css.rateRow}>
            <span className={css.rate}>
              {intl.formatMessage({ id: 'ForBusiness.pricingRate' })}
            </span>
            <span className={css.rateLabel}>
              {intl.formatMessage({ id: 'ForBusiness.pricingRateLabel' })}
            </span>
          </div>
          <ul className={css.featureList}>
            {PRICING_ITEMS.map(id => (
              <li key={id} className={css.featureItem}>
                <CheckCircle2Icon className={css.checkIcon} />
                {intl.formatMessage({ id })}
              </li>
            ))}
          </ul>
          <NamedLink
            className={css.cta}
            name="SignupForUserTypePage"
            params={{ userType: 'provider' }}
          >
            {intl.formatMessage({ id: 'ForBusiness.listMyBusiness' })}
            <ArrowRightIcon className={css.ctaArrow} />
          </NamedLink>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
